import { EditIcon, EllipsisVerticalIcon, Trash2Icon } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { DialogStateManager } from '@plato/ui-legacy/components/dialog/dialog-provider';
import { Button } from '@plato/ui-legacy/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@plato/ui/containers/dropdown-menu';
import { MenuItemLabel, MenuItemLeading } from '@plato/ui/primitives/menu';
import { useDialogs } from '../../../dialogs/all-dialogs.tsx';
import { DeleteTaskDialog } from '../delete-task-dialog.tsx';

type TaskOptionsDropdownProps = {
    taskId: string;
};

export function TaskOptionsDropdown({ taskId }: TaskOptionsDropdownProps) {
    const [open, setOpen] = React.useState(false);
    const { t } = useTranslation();
    const { openTaskDetails } = useDialogs();

    const handleEditClick = () => {
        openTaskDetails(taskId);
    };

    const handleDeleteClick = () => {
        void DialogStateManager.show(DeleteTaskDialog, { taskId, source: 'task_overview_page' });
    };

    return (
        <div className="flex justify-center">
            <DropdownMenu open={open} onOpenChange={setOpen}>
                <DropdownMenuTrigger
                    render={
                        <Button
                            variant="icon"
                            icon={EllipsisVerticalIcon}
                            aria-label={t('task_overview_table__options_aria', { ns: 'tasks' })}
                        />
                    }
                />
                <DropdownMenuContent align="end" side="bottom">
                    <DropdownMenuItem onClick={handleEditClick}>
                        <MenuItemLeading className="text-inherit">
                            <EditIcon />
                        </MenuItemLeading>
                        <MenuItemLabel>
                            {t('task_overview_table__options__edit_task', { ns: 'tasks' })}
                        </MenuItemLabel>
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={handleDeleteClick} className="text-danger">
                        <MenuItemLeading className="text-danger">
                            <Trash2Icon />
                        </MenuItemLeading>
                        <MenuItemLabel>
                            {t('task_overview_table__options__delete_task', { ns: 'tasks' })}
                        </MenuItemLabel>
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
}
